// client secrets
export const googleAnalyticsId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
export const contentSquareId = process.env.NEXT_PUBLIC_CONTENT_SQUARE_ID

export const cookiebotDisabled =
  process.env.NEXT_PUBLIC_COOKIEBOT_DISABLED === "true"

// server secrets

export const emailLeadEnabled = process.env.EMAIL_LEAD_ENABLED === "true"
export const salesforceLeadEnabled =
  process.env.SALESFORCE_LEAD_ENABLED === "true"

export const sendgridLeadEnabled = process.env.SENDGRID_LEAD_ENABLED === "true"
export const sendgridApiKey = process.env.SENDGRID_API_KEY!
export const sendgridLeadEmailTemplate =
  process.env.SENDGRID_LEAD_EMAIL_TEMPLATE!

export const notionLeadEnabled = process.env.NOTION_LEAD_ENABLED === "true"
export const notionApiKey = process.env.NOTION_API_KEY
export const notionLeadsDatabaseId = process.env.NOTION_LEADS_DATABASE_ID

export const pipedriveLeadEnabled = process.env.ENABLE_PIPEDRIVE_PUSH === "true"
export const pipedriveApiKey = process.env.PIPEDRIVE_API_KEY
export const pipedriveLeadLabel = process.env.PIPEDRIVE_LEAD_LABEL || "Lead"

export const leadNotificationRecipients = (
  process.env.LEAD_NOTIFICATIONS_ADDRESS ?? ""
)
  .split(";")
  .map((x) => x.trim())

export const sanityViewerToken = process.env.SANITY_API_READ_TOKEN

export const sesEmailDefaultSender = process.env.SES_EMAIL_DEFAULT_SENDER
export const sesAwsRegion = process.env.SES_AWS_REGION
export const sesAwsAccessKeyId = process.env.SES_AWS_ACCESS_KEY_ID
export const sesAwsSecretAccessKey = process.env.SES_AWS_SECRET_ACCESS_KEY

export const notificationsBccAddress =
  process.env.NOTIFICATIONS_BCC_ADDRESSES?.split(";").map((x) => x.trim())

export const googleTagManagerId =
  process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID || "GTM-NBMJW8NG"
